import React from 'react';
import { QuizStep } from '../../lib/quiz-definition';

interface PreCheckoutStepProps {
    step: QuizStep;
    onNext: (nextStepId: string) => void;
}

const PreCheckoutStep: React.FC<PreCheckoutStepProps> = ({ step, onNext }) => {
    // NOTE: This structure uses placeholders based on the design.
    // Actual plan details, testimonials, etc., would need to be fetched or passed as props.

    const handlePayment = (method: string) => {
        console.log(`Payment button clicked: ${method} - Navigating to post_checkout_full`);
        // TODO: Add actual Stripe integration logic later
        
        // Navigate to the 'full' message step
        onNext("post_checkout_full"); 
        
        // alert(`Payment initiated with ${method}. Add Stripe logic!`); // Removed alert
    }

    return (
        <div className="precheckout-step-content">
            {/* Added a scrollable content wrapper */}
            <div className="precheckout-scrollable-content">
                {/* Plan Options Section */}
                <section className="precheckout-section precheckout-plans">
                    {/* Plan 1 (Popular) */}
                    <div className="plan-card popular">
                        <div className="plan-tags">
                            <span className="tag popular-tag">MOST POPULAR</span>
                            <span className="tag save-tag">SAVE 20%</span>
                        </div>
                        <h3 className="plan-title">12 Months</h3>
                        <div className="plan-price">
                            <span className="price-amount">$37.49</span>
                            <span className="price-term">/month</span>
                        </div>
                        <p className="plan-billing">Billed annually ($449.90)</p>
                    </div>
                    {/* Plan 2 (Monthly) */}
                    <div className="plan-card">
                        <h3 className="plan-title">Monthly</h3>
                        <div className="plan-price">
                            <span className="price-amount">$49.90</span>
                            <span className="price-term">/month</span>
                        </div>
                        <p className="plan-billing">Billed monthly</p>
                    </div>
                </section>

                {/* === START Moved Payment Buttons === */}
                 <div className="payment-options">
                     <button className="payment-btn apple-pay" onClick={() => handlePayment('Apple Pay')}><i></i> Apple Pay</button>
                     <button className="payment-btn link-pay" onClick={() => handlePayment('Link')}><i>🔗</i> Pay with Link</button>
                 </div>
                 <div className="payment-divider">
                     <hr />
                     <span>or</span>
                 </div>
                {/* === END Moved Payment Buttons === */}

                {/* === START Payment Details Section === */}
                <section className="precheckout-section precheckout-payment-details" id="payment-details">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                        {/* Placeholder for lock icon */}
                        <span style={{ color: '#10B981' }}>🔒</span> 
                        <span style={{ fontSize: '0.875rem', color: '#059669', fontWeight: 500 }}>Secure Payment</span>
                    </div>
                    
                    <form className="quiz-form space-y-4" onSubmit={(e) => e.preventDefault()}> 
                        <div>
                            <label className="quiz-label">Cardholder Name</label>
                            <input type="text" placeholder="Name on card" className="quiz-input" />
                        </div>
                        
                        <div>
                            <label className="quiz-label">Card Number</label>
                            <div style={{ position: 'relative' }}>
                                <input type="text" placeholder="1234 5678 9012 3456" className="quiz-input" />
                                <div style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '0.5rem', color: '#9CA3AF' }}>
                                    {/* Placeholders for card icons */}
                                    <span>Visa</span> <span>MC</span> <span>Amex</span>
                                </div>
                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <div style={{ flex: 1 }}>
                                <label className="quiz-label">Expiry Date</label>
                                <input type="text" placeholder="MM/YY" className="quiz-input" />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label className="quiz-label">CVV</label>
                                <input type="text" placeholder="123" className="quiz-input" />
                            </div>
                        </div>
                    </form>
                </section>
                {/* === END Payment Details Section === */}

                {/* REMOVED Card Pay Button */}
                {/* <button className="payment-btn card-pay" onClick={() => handlePayment('Card')}><i>💳</i> Pay with Card</button> */} 
                
                {/* Disclaimer moved below form section */}
                 <p className="payment-disclaimer">No commitment. Cancel anytime.</p>

                {/* Testimonial Section */}
                <section className="precheckout-section precheckout-testimonial">
                    <h2>What our users say</h2>
                    {/* Added scrollable container */}
                    <div className="testimonial-scroll-container">
                        {/* Testimonial 1 */}
                        <div className="testimonial-card">
                            <div className="testimonial-header">
                                <img src="/images/avatars/Avatar user-1.png" alt="Sarah M." className="testimonial-avatar" />
                                <div className="testimonial-info">
                                    <span className="testimonial-name">Sarah M.</span>
                                    <div className="testimonial-rating">⭐⭐⭐⭐⭐</div> 
                                </div>
                            </div>
                            <p className="testimonial-quote">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Absolutely love it!"</p>
                        </div>
                        {/* Testimonial 2 (Duplicate) */}
                        <div className="testimonial-card">
                            <div className="testimonial-header">
                                <img src="/images/avatars/Avatar user-2.png" alt="John D." className="testimonial-avatar" />
                                <div className="testimonial-info">
                                    <span className="testimonial-name">John D.</span>
                                    <div className="testimonial-rating">⭐⭐⭐⭐⭐</div> 
                                </div>
                            </div>
                            <p className="testimonial-quote">"This app changed how I find places when travelling. So much easier!"</p>
                        </div>
                        {/* Testimonial 3 (Duplicate) */}
                        <div className="testimonial-card">
                             <div className="testimonial-header">
                                <img src="/images/avatars/Avatar user-3.png" alt="Emily R." className="testimonial-avatar" />
                                <div className="testimonial-info">
                                    <span className="testimonial-name">Emily R.</span>
                                    <div className="testimonial-rating">⭐⭐⭐⭐</div> 
                                </div>
                            </div>
                            <p className="testimonial-quote">"Really helpful for finding hidden gems in my own city. Highly recommend."</p>
                        </div>
                     </div> 
                </section>

                {/* Features Section */}
                <section className="precheckout-section precheckout-features">
                     <h2>What's included</h2>
                    <ul className="features-list">
                        <li><span className="feature-icon">✓</span> Lorem ipsum dolor sit amet</li>
                        <li><span className="feature-icon">✓</span> Consectetur adipiscing elit</li>
                        <li><span className="feature-icon">✓</span> Sed do eiusmod tempor incididunt</li>
                    </ul>
                </section>

                {/* FAQ Section */}
                <section className="precheckout-section precheckout-faq">
                     <h2>Frequently Asked Questions</h2>
                    <div className="faq-list">
                        <div className="faq-item">
                            <button className="faq-question">How does the free trial work? <span className="faq-icon">▼</span></button>
                            {/* <div className="faq-answer">Answer here...</div> */}
                        </div>
                         <div className="faq-item">
                            <button className="faq-question">Can I cancel anytime? <span className="faq-icon">▼</span></button>
                             {/* <div className="faq-answer">Answer here...</div> */} 
                        </div>
                     </div>
                 </section>

                 {/* Support Section */}
                 <section className="precheckout-section precheckout-support">
                     <p>Need help? Contact our support team</p>
                     <a href="mailto:support@atly.com" className="support-email">support@atly.com</a>
                 </section>
            </div> {/* End of scrollable wrapper */}
        </div>
    );
};

export default PreCheckoutStep; 